import React from 'react';
import * as Sentry from '@sentry/react';
import { Box, Heading, Text, Button, VStack, Container } from '@chakra-ui/react';

const ErrorFallback = ({ error, resetError }) => {
  return (
    <Container maxW="container.md" py={16}>
      <Box
        p={8}
        borderWidth="1px"
        borderColor="red.200"
        borderRadius="2xl"
        bg="red.50"
        boxShadow="xl"
        textAlign="center"
      >
        <VStack spacing={4}>
          <Heading size="lg" color="#620404">
            Something went wrong
          </Heading>
          <Text color="gray.700" fontSize="md">
            An unexpected error occurred. Our technical team has been notified automatically via Sentry.
          </Text>
          {process.env.NODE_ENV !== 'production' && error && (
            <Box
              w="100%"
              p={4}
              bg="white"
              borderRadius="md"
              border="1px solid"
              borderColor="gray.200"
              textAlign="left"
              fontSize="xs"
              fontFamily="monospace"
              overflowX="auto"
              color="red.600"
            >
              {error.toString()}
            </Box>
          )}
          <Button
            bg="#620404"
            color="white"
            _hover={{ bg: '#4a0303' }}
            onClick={() => {
              if (resetError) resetError();
              window.location.reload();
            }}
          >
            Reload Page
          </Button>
        </VStack>
      </Box>
    </Container>
  );
};

export const SentryErrorBoundary = ({ children, fallback }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={fallback || (({ error, resetError }) => <ErrorFallback error={error} resetError={resetError} />)}
      showDialog={false}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary;
